// src/components/ui/Icon/groupIconOptions.ts
//
// Catálogo dos ícones que o dono da loja pode escolher para um grupo do menu.
// Fonte única: o seletor do Admin itera sobre ele e o Store valida contra ele.
// Adicionar um ícone = um path novo em ICON_PATHS + uma entrada aqui.
//
// A ordem define a ordem da grade no seletor: agrupada por afinidade
// (genérico, salgados, pratos, padaria/doces, bebidas, promoção).

export interface GroupIconOption {
  slug: string;
  label: string;
}

export const GROUP_ICON_OPTIONS: ReadonlyArray<GroupIconOption> = [
  { slug: "utensils", label: "Geral" },
  { slug: "pizzaSlice", label: "Pizza" },
  { slug: "burger", label: "Lanches" },
  { slug: "hotDog", label: "Hot dog" },
  { slug: "steak", label: "Carnes" },
  { slug: "drumstick", label: "Porções / Frango" },
  { slug: "sushi", label: "Japonesa" },
  { slug: "fish", label: "Peixes" },
  { slug: "salad", label: "Saladas" },
  { slug: "noodles", label: "Massas" },
  { slug: "bowl", label: "Marmitas / Açaí" },
  { slug: "bread", label: "Padaria" },
  { slug: "cake", label: "Bolos / Doces" },
  { slug: "iceCream", label: "Sorvetes" },
  { slug: "coffee", label: "Cafés" },
  { slug: "cup", label: "Bebidas" },
  { slug: "bottle", label: "Refrigerantes" },
  { slug: "beer", label: "Cervejas" },
  { slug: "wine", label: "Drinks / Vinhos" },
  { slug: "flame", label: "Promoções" },
];

const SLUGS = new Set(GROUP_ICON_OPTIONS.map((option) => option.slug));

/**
 * Um valor vindo da API só é aceito como ícone se estiver no catálogo.
 * Slug desconhecido (typo gravado na mão, ícone removido no futuro) cai no
 * mesmo caminho de `null` — degrada para o cálculo automático em vez de
 * renderizar um SVG vazio.
 */
export function isGroupIconSlug(value: unknown): value is string {
  return typeof value === "string" && SLUGS.has(value);
}
